import { Section } from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import { Card, Stack, Text } from 'braid-design-system';
import type { SalariesTabModel } from '../../../pages/salaries/salariesTabModel';
import translations from './.vocab/index';

interface SalariesByRoleSectionProps {
  model: Pick<SalariesTabModel, 'companyName'>;
}

export const SalariesByRoleSection = ({
  model,
}: SalariesByRoleSectionProps) => {
  const { companyName } = model;
  const { t } = useTranslations(translations);

  const mockRoleName = 'Mocked software engineer'; // This should be replaced with the actual role name from the model or params

  return (
    <Section
      mode={'view'}
      heading={t('role salary at companyName', {
        companyName,
        role: mockRoleName,
      })}
      padding={'none'}
    >
      <Card>
        <Stack space="small">
          <Text>Placeholder</Text>
        </Stack>
      </Card>
    </Section>
  );
};
